module.exports = __webpack_public_path__ + "media/images/category/feature/coj_f/coj_f-1-c45104bac3a3a6e1e113cd1dfbc23886.jpg";